import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';
import {
  loadForgotPasswordsUserNeedsHelpRequest,
  loadForgotPasswordsUserNeedsHelpSuccess,
  loadForgotPasswordsUserNeedsHelpFailure,
  clearForgotPasswordsUserNeedsHelpFailure
} from '../actions/forgot-passcode.actions';
import { IForgotPasscodeRequest, IForgotPasscodeResponse } from '../models/forgot-passcode.model';

export const forgotPasswordUserNeedsHelpFeatureKey = 'forgotPasscode';

export interface ForgotPasscode {
  isLoading: boolean;
  forgotPasscodeUserNeedsHelpRequest: IForgotPasscodeRequest;
  forgotPasscodeUserNeedsHelpResponse: IForgotPasscodeResponse;
  forgotPasscodeUserNeedsHelpFailure: IGenericError<ErrorResponse>;
}

export const initialState: ForgotPasscode = {
  isLoading: false,
  forgotPasscodeUserNeedsHelpRequest: undefined,
  forgotPasscodeUserNeedsHelpResponse: undefined,
  forgotPasscodeUserNeedsHelpFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadForgotPasswordsUserNeedsHelpRequest, (state, action) => ({
    ...state,
    forgotPasscodeUserNeedsHelpRequest: action.request,
    isLoading: true
  })),

  on(loadForgotPasswordsUserNeedsHelpSuccess, (state, action) => ({
    ...state,
    forgotPasscodeUserNeedsHelpResponse: action.response,
    isLoading: false
  })),

  on(loadForgotPasswordsUserNeedsHelpFailure, (state, action) => ({
    ...state,
    forgotPasscodeUserNeedsHelpFailure: action.error,
    isLoading: false
  })),

  on(clearForgotPasswordsUserNeedsHelpFailure, (state, action) => ({
    ...state,
    forgotPasscodeUserNeedsHelpFailure: undefined
  }))
);

export const getForgotPasswordsUserNeedsHelpRequest = (state: ForgotPasscode) => state.forgotPasscodeUserNeedsHelpRequest;
export const getForgotPasswordsUserNeedsHelpResponse = (state: ForgotPasscode) => state.forgotPasscodeUserNeedsHelpResponse;
export const getForgotPasswordsUserNeedsHelpFailure = (state: ForgotPasscode) => state.forgotPasscodeUserNeedsHelpFailure;
export const getForgotPasswordsUserNeedsHelpIsLoading = (state: ForgotPasscode) => state.isLoading;
